import { EllipsedText } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { jobActivityState, selectedJobActivityIdState } from '../../../storage/jobTypesStates';

type Props = {
  activityId: string;
};
export function JobActivityListItem({ activityId }: Readonly<Props>) {
  const { theme } = useStyles();
  const [selectedActivity, setSelectedActivity] = useRecoilState(selectedJobActivityIdState);
  const isSelected = selectedActivity === activityId;
  const activity = useRecoilValue(jobActivityState(activityId));

  if (!activity) return null;

  const onSelectActivity = () => {
    setSelectedActivity(activityId);
  };

  return (
    <ListItem
      overrides={{
        Root: {
          props: {
            onClick: onSelectActivity,
          },
          style: {
            cursor: 'pointer',
            backgroundColor: isSelected ? theme.colors.backgroundTertiary : undefined,
            ':hover': {
              backgroundColor: theme.colors.backgroundSecondary,
            },
          },
        },
        Content: {
          style: {
            marginLeft: 0,
            paddingLeft: theme.sizing.scale600,
          },
        },
      }}
      sublist
    >
      <ListItemLabel description={activity.description}>
        <EllipsedText inline>{activity.name}</EllipsedText>
      </ListItemLabel>
    </ListItem>
  );
}
